// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1Yu-C","emails":"CreateEditClinics_emails__1Rato","emailTagLabel":"CreateEditClinics_emailTagLabel__2J0gs"};